export default function Footer() {
  return (
    <footer id="footer" className="pt-16 md:pt-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
            <div className="md:col-span-1">
              <div className="text-xl font-heading font-black text-foreground-950 mb-4">
                黑料<span className="text-primary-500">视频</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                全网最狠吃瓜基地。每日整理明星八卦、网红黑料、暴走视频合集。
                拒绝官腔，只爆猛料，凌晨更新传送门不迷路。
              </p>
            </div>

            <div>
              <h4 className="text-xs font-bold text-foreground-700 uppercase tracking-wider mb-4">
                快速导航
              </h4>
              <div className="flex flex-col gap-2.5">
                <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">热度榜单</a>
                <a href="#cards" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">今日爆料</a>
                <a href="#updates" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">实时快讯</a>
                <a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">焦点专题</a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-bold text-foreground-700 uppercase tracking-wider mb-4">
                更多入口
              </h4>
              <div className="flex flex-col gap-2.5">
                <a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">专题索引</a>
                <a href="#topics" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">热门话题</a>
                <a href="#media" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">视频专区</a>
                <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">常见问答</a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-bold text-foreground-700 uppercase tracking-wider mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap justify-center">
              <span>&copy; 2026 黑料视频</span>
              <span className="hidden sm:inline">|</span>
              <span>用户协议</span>
              <span className="hidden sm:inline">|</span>
              <span>隐私政策</span>
              <span className="hidden sm:inline">|</span>
              <span>免责声明</span>
            </div>

            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer no-underline"
                aria-label="社交媒体"
              >
                <i className="ri-weibo-line text-sm text-background-50 w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer no-underline"
                aria-label="社交媒体"
              >
                <i className="ri-wechat-line text-sm text-background-50 w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}